import React from 'react';
import PropTypes from 'prop-types';
import { arrayOf, params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import { Badge } from '@one-thd/sui-atomic-components';

export const ProductFuelType = ({ itemId }) => {

  const { data } = useDataModel('product', {
    variables: {
      itemId
    },
  });

  const { product } = data || {};
  if (!product || !Array.isArray(product.fuelTypeOptions) || product.fuelTypeOptions.length <= 1) return null;

  // Sort so defaultOption comes first and limit it to three options
  const sortedOptions = [...product.fuelTypeOptions]
    .sort((optionA, optionB) => {
      if (optionA.defaultOption === optionB.defaultOption) return 0;
      return optionA.defaultOption ? -1 : 1;
    })
    .slice(0, 3);

  return (
    <div id="product-fuel-type">
      <div className="sui-flex sui-gap-2 sui-items-center">
        <span className="sui-text-subtle sui-font-small sui-text-xs">Options Available</span>
        <span className="sui-ml-2 sui-flex sui-gap-2">
          {sortedOptions.map((opt, idx) => (
            <Badge
              key={`${opt.fuelType || 'fuel'}-${idx}`}
              color="medium"
              variant={opt.defaultOption ? 'strong' : 'regular'}
              size="small"
            >
              {opt.fuelType}
            </Badge>
          ))}
        </span>
      </div>
      {sortedOptions[0]?.fuelType && (
      // eslint-disable-next-line
        <div className="sui-text-[1.1rem] sui-text-subtle sui-font-normal">
          Price Shown for {sortedOptions[0].fuelType}
        </div>
      )}
    </div>
  );
};

ProductFuelType.propTypes = {
  itemId: PropTypes.string.isRequired
};

ProductFuelType.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    fuelTypeOptions: arrayOf(shape({
      fuelType: string(),
      defaultOption: string()
    }))
  })
};

ProductFuelType.displayName = 'ProductFuelType';
